import React from "react";
import { Container, Typography, Divider } from "@mui/material";
import { useTranslation } from 'react-i18next';

export default function DictionaryGuide() {
    const { t } = useTranslation();
    return (
        <Container maxWidth="md" sx={{ mt: '50px', py: 4 }}>
            <Typography variant="h3" gutterBottom>
                {t('Footer.DictionaryGuide')}
            </Typography>

            <Divider sx={{ my: 2 }} />

            <Typography paragraph>
                {t('Guides.DictionaryGoal')}
            </Typography>

            <Typography paragraph>
                {t('Guides.ContentLater')}
            </Typography>
        </Container>
    );
}
